import React, { useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { red, yellow } from "@mui/material/colors";
import HideImageIcon from "@mui/icons-material/HideImage";
import NoRowItem from "../NoItemRow";
import AccordionCell from "../AccordionCell";
import { useTranslation } from "react-i18next";
import TextField from "@mui/material/TextField";
import Chip from '@mui/material/Chip';

const TableItemRow = ({ ...props }) => {
  const { i18n } = useTranslation();
  var language = i18n.language;
  const [item, setItem] = useState(props.row);

  const update = (value) => {
    setItem({
      ...item,
      stock: value
    })
    props.setProductDTO({
      ...item,
      stock: value
    });
  }

  return (
    <React.Fragment>
      <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
        <AccordionCell
          isGroups={props.isGroups}
          isProductGroupOpen={props.isProductGroupOpen}
          closeAccording={props.closeAccording}
          getProductsFromGroup={props.getProductsFromGroup}
          row={props.row}
        />
        <TableCell align="right">
          {props.row.id ? props.row.id : "No data"}
        </TableCell>
        <TableCell align="right">
          {props.row.name
            ? language === "en"
              ? props.row.name
              : language === "fr"
              ? props.row.name_fr
              : language === "de"
              ? props.row.name_de
              : language === "it"
              ? props.row.name_it
              : props.row.name
            : "No data"}
        </TableCell>
        {!props.isGroups &&
          <TableCell align="center" style={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "center", margin: "0 !important" }}>
            <TextField
              id="outlined-basic"
              label="On stock"
              placeholder="On stock"
              variant="outlined"
              style={{ width: "100px" }}
              value={item.stock}
              onChange={(e) => update(e.target.value)}
              />
            <Chip label="Save" variant="outlined" color="primary" onClick={props.editProduct}/>
          </TableCell>
        }
        <TableCell align="center">
          {props.isGroups ? (
            props.row.image?.includes("https://res.cloudinary.com") ? (
              <img
                src={props.row.image}
                alt="group"
                style={{
                  height: "50px",
                  width: props.isGroups ? "200px" : "50px",
                }}
              />
            ) : (
              <HideImageIcon
                style={{
                  height: "50px",
                  width: "50px",
                  color: "#001753 !important",
                }}
              />
            )
          ) : props.row.image &&
            props.row.image[0]?.includes("https://res.cloudinary.com") ? (
            <img
              src={props.row.image[0]}
              alt="product"
              style={{
                height: "50px",
                width: props.isGroups ? "200px" : "50px",
              }}
            />
          ) : (
            <HideImageIcon
              style={{
                height: "50px",
                width: "50px",
                color: "#001753 !important",
              }}
            />
          )}
        </TableCell>
        <TableCell align="center">
          {props.row.name === "No data" ? (
            "No data"
          ) : (
            <EditIcon
              sx={{ color: yellow[700] }}
              style={{ cursor: "pointer" }}
              onClick={
                props.isGroups
                  ? () => props.openEditGroup(props.row.id)
                  : () => props.openEditProduct(props.row.id)
              }
            />
          )}
        </TableCell>
        <TableCell align="center">
          {props.row.name === "No data" ? (
            "No data"
          ) : (
            <DeleteIcon
              sx={{ color: red[800] }}
              style={{ cursor: "pointer" }}
              onClick={
                props.isGroups
                  ? () => props.deleteGroup(props.row.id)
                  : () => props.deleteProduct(props.row.id)
              }
            />
          )}
        </TableCell>
      </TableRow>
      {props.isGroups && props.isProductGroupOpen === props.row.id ? (
        props.productsFromGroup && props.productsFromGroup.length > 0 ? (
          props.productsFromGroup.map((row) => (
            <TableRow
              key={`${row.name}_${row.id}`}
              className="product-from-group"
            >
              <TableCell align="right">
                <em>Product</em>
              </TableCell>
              <TableCell align="right">{row.id ? row.id : "No data"}</TableCell>
              <TableCell align="right">
                {row.name ? row.name : "No data"}
              </TableCell>
              <TableCell align="center">
                {row &&
                Array.isArray(row.image) &&
                row.image[0]?.includes("https://res.cloudinary.com") ? (
                  <img
                    src={row.image[0]}
                    alt="group"
                    style={{ height: "50px", width: "50px" }}
                  />
                ) : (
                  <HideImageIcon
                    style={{
                      height: "50px",
                      width: "50px",
                      color: "#001753 !important",
                    }}
                  />
                )}
              </TableCell>
              <TableCell align="center">
                <EditIcon
                  sx={{ color: yellow[700] }}
                  style={{ cursor: "pointer" }}
                  onClick={() => props.openEditProduct(row.id, props.row.id)}
                />
              </TableCell>
              <TableCell align="center">
                <DeleteIcon
                  sx={{ color: red[800] }}
                  style={{ cursor: "pointer" }}
                  onClick={() => props.deleteProduct(row.id, props.row.id)}
                />
              </TableCell>
            </TableRow>
          ))
        ) : (
          <NoRowItem isGroups={props.isGroups} />
        )
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default TableItemRow;
